import { Component, OnInit, Input } from '@angular/core';

/**
 * This component is the action button that opens the dropdown
 */

@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    standalone: false
})
export class ActionButtonComponent implements OnInit {

  @Input() disabled : boolean; 
  @Input() id: string;
  @Input() fab: 'default' | 'big' | undefined;

  constructor() { }

  ngOnInit() { }

}
